import React from "react";
import { Bar } from "react-chartjs-2";
import { languageService } from "../../../../Language/language.service";

function abbreviateName(name) {
  const str = name.split(" ");
  let word = "";
  if (str.length > 1) {
    str.forEach((el) => {
      word += el.charAt(0);
    });
  } else {
    word = name;
  }
  return word;
}
const htmlLegendPlugin = {
  id: "htmlLegend",
  afterUpdate(chart) {
    const pluginOptions = chart.options && chart.options.plugins && chart.options.plugins.htmlLegend;

    if (!pluginOptions || !pluginOptions.containerID) return;

    const container = document.getElementById(pluginOptions.containerID);
    if (!container) return;

    container.innerHTML = "";

    const ul = document.createElement("ul");
    ul.style.display = "flex";
    ul.style.justifyContent = "center";
    ul.style.gap = "20px";
    ul.style.margin = "0";
    ul.style.padding = "0";
    ul.style.listStyle = "none";

    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      const isHidden = meta.hidden === true || dataset.hidden === true;

      const li = document.createElement("li");
      li.style.cursor = "pointer";
      li.style.display = "flex";
      li.style.alignItems = "center";
      li.style.gap = "6px";

      li.onclick = () => {
        meta.hidden = meta.hidden === null ? !chart.data.datasets[i].hidden : null;
        chart.update();
      };

      const box = document.createElement("span");
      box.style.width = "12px";
      box.style.height = "12px";
      box.style.background = dataset.backgroundColor;
      box.style.display = "inline-block";
      box.style.opacity = isHidden ? "0.3" : "1";

      const text = document.createElement("span");
      text.style.fontSize = "14px";
      text.style.fontWeight = "500";
      text.innerText = dataset.label;

      // ✅ STRIKE THROUGH WHEN DISABLED
      text.style.textDecoration = isHidden ? "line-through" : "none";
      text.style.opacity = isHidden ? "0.5" : "1";

      li.appendChild(box);
      li.appendChild(text);
      ul.appendChild(li);
    });

    container.appendChild(ul);
  },
};

const GroupedBarChart = ({ data }) => {
  const labels = data.map((item) => abbreviateName(item.location));
  const fullLabels = data.map((item) => item.location); // keep full names

  const chartData = {
    labels,
    datasets: [
      {
        label: languageService("Inspections"),
        backgroundColor: "#EA4335",
        data: data.map((item) => item.inspections),
      },
      {
        label: languageService("Work Orders"),
        backgroundColor: "#4285F4",
        data: data.map((item) => item.maintenance),
      },
      {
        label: languageService("Maintenance"),
        backgroundColor: "#34A853",
        data: data.map((item) => item.executions),
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    // title: {
    //   display: true,
    //   text: "Activity Summary by Location",
    //   font: {
    //     size: 16,
    //   },
    // },
    plugins: {
      htmlLegend: {
        containerID: "legend-container",
      },
    },
    title: false,
    tooltips: {
      callbacks: {
        title: function (tooltipItems) {
          const index = tooltipItems[0].index;
          return fullLabels[index]; // show full location name
        },
      },
    },

    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 45,
          },
        },
      ],
      yAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true,
            precision: 0,
          },
        },
      ],
    },
  };

  const scrollable = data.length > 15;
  const containerWidth = scrollable ? data.length * 40 : "100%"; // 40px per item

  return (
    <div style={{ width: "100%", height: "340px" }}>
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          marginBottom: "6px",
        }}
      >
        {languageService("Location Activity Summary")}
      </div>

      {/* ✅ INTERACTIVE, FIXED LEGEND */}
      <div id="legend-container" style={{ marginBottom: "10px" }} />

      {/* ✅ ONLY CHART SCROLLS */}
      <div style={{ overflowX: "auto", height: "100%" }}>
        <div style={{ width: containerWidth, height: "300px" }}>
          <Bar data={chartData} options={options} plugins={[htmlLegendPlugin]} />
        </div>
      </div>
    </div>
  );
};

export default GroupedBarChart;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/barGraphWidget/Chart.jsx